<template>
  <div class="mt-4 mb-5">
    <!-- Basic Details - Start -->
    <div class="row">
      <div class="col-12 pr-5 pl-5 mt-4">
        <disk-space-alert v-if="showDiskAlert" />
        <div class="row">
          <div class="col-md-12">
            <h5>Disk Usage <span v-if="showDiskAlert">( <a  target="_blank" :href="alertDetails.dur_link">{{ alertDetails.dur_link }}</a> )</span></h5>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">SolusVM Disk Space (GB)</label>
          <div class="col-sm-10 col-md-4 col-lg-4">
            <div class="input-group">
              <input type="text" class="form-control" name="used" readonly :value="showNice(account.hdd.used)" />
              <b class="mt-2 ml-3 mr-3">Of</b>
              <input type="text" class="form-control" name="total" readonly :value="showNice(account.hdd.total)" />
              <div class="input-group-append">
                <button style="margin: 0" class="btn btn-primary btn-sm" type="button" @click="openChangeHddModal()"><i class="fa fa-pencil"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <change-hdd-modal ref="hddModal" />
  </div>
</template>

<script>
import DiskSpaceAlert from '../../../../components/Helps/DiskSpaceAlert.vue'
import changeHddModal from './changeHddModal'
export default {
  name: "DiskSpace",
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  components: {
    DiskSpaceAlert,
    changeHddModal
  },
  computed: {
    showDiskAlert() {
      return this.$store.getters["alert/showDiskAlert"];
    },
    alertDetails() {
      return this.$store.getters["alert/getAlertDetails"];
    }
  },
  methods: {
    showNice(bytes){
      return (bytes / Math.pow(1024, 3)).toFixed(2) + ' GB';
    },
    openChangeHddModal() {
      this.$refs.hddModal.load(this.account)
    },
  }
}
</script>

<style scoped>

</style>
